import { useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import { FieldArray } from 'react-final-form-arrays';
import { Grid } from '@mui/material';

import { Button, Typography, Chip } from '@occc/ui-design-system';
import { TextField } from '@occc-app/design-system';
import { parseAttributeInput } from '@occc-app/routes/Location/LocationUpdatePage/utils';

export const StoreAttributes = () => {
  const [attribute, setAttribute] = useState<string>('');

  return (
    <div>
      <Typography variant='body2' color='textSecondary' paragraph>
        Add the services available at your location for display in the mobile app such as "Car
        Wash", "Coffee" or "Public Restrooms." Enter a single service or a comma separated list
      </Typography>

      <FieldArray name='details.availableServices'>
        {({ fields }) => {
          const handleAddAttribute = (newAttribute: string) => {
            const attributeList = newAttribute.split(',');
            attributeList.forEach((attribute) => {
              const trimmedAttribute = attribute.trim();

              if (isEmpty(trimmedAttribute)) return;

              fields.push(trimmedAttribute);
            });

            setAttribute('');
          };

          const handleRemoveAttribute = (index: number) => {
            fields.remove(index);
          };

          const handleSubmitAttributes = (attributes: string) => {
            setAttribute(attributes);
          };

          return (
            <>
              <Grid container alignItems='center' spacing={3}>
                <Grid item xs={12} sm={9}>
                  <TextField
                    onChange={({ target }) => handleSubmitAttributes(target.value)}
                    label='Available Services'
                    name='name'
                    value={attribute}
                    required={false}
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Button
                    variant='contained'
                    color='primary'
                    disabled={!parseAttributeInput(attribute).length}
                    onClick={() => handleAddAttribute(attribute)}
                  >
                    Add Service
                  </Button>
                </Grid>
              </Grid>
              <div>
                {fields && fields.value
                  ? fields.value
                      .filter((name) => !isEmpty(name.trim()))
                      .map((name, index) => {
                        return (
                          <Chip
                            sx={{ my: 1, mr: 1 }}
                            key={`chip-${name}=${index.toString()}`}
                            label={name}
                            onDelete={() => handleRemoveAttribute(index)}
                          />
                        );
                      })
                  : null}
              </div>
            </>
          );
        }}
      </FieldArray>
    </div>
  );
};
